<template>
  <validation-observer v-slot="{ handleSubmit }">
    <div class="row">
      <div class="col-md-12 text-bold bold mb-3">
        <i class="fas fa-ticket-alt color-orange" />
        Reclamación
      </div>
      <div class="col-md-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <custom-date-picker
            v-model="model.claimDate"
            class-container="w-100"
            custom-error-msg="Favor seleccione la fecha de reclamación."
            :error="errors[0]"
            label="Fecha:"
            :max-date="new Date()"
            :min-date="beforeBankRequestDate"
            placeholder="DD/MM/YYYY"
          />
        </validation-provider>
      </div>
      <div class="col-md-3">
        <validation-provider v-slot="{ errors }" rules="required">
          <div class="data-name">Tipo de Reclamación</div>
          <custom-radio-group
            v-model="claimTypeSelected"
            class="row mt-3"
            custom-error-msg="Favor seleccione PIN o Tarjeta."
            :error="errors[0]"
            field-key="value"
            :is-inline="true"
            name="claimTypes"
            :options="radioButtonsOptions"
          />
        </validation-provider>
      </div>
      <div class="col-md-3">
        <custom-input
          v-model="model.claimCardNumber"
          label="Número de tarjeta:"
          type="number"
        />
      </div>
      <div v-if="showReasons" class="col-md-3">
        <validation-provider
          v-slot="{ errors }"
          :rules="`${claimTypeSelected == false ? 'required' : ''}`"
        >
          <custom-drop-down
            v-model="claimReasonSelected"
            :clearable="false"
            custom-error-msg="Favor seleccionar razón."
            :error="errors[0]"
            fieldkey="id"
            fieldname="name"
            label="Razón:"
            :options="claimReasons"
            placeholder="Seleccione"
          />
        </validation-provider>
      </div>

      <div class="col-md-12 mt-2">
        <div class="row">
          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="model.claimName"
                custom-error-msg="Nombre de quien reclama es requerido."
                :error="errors[0]"
                label="Nombre de quien reclama:"
              />
            </validation-provider>
          </div>
          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-drop-down
                v-model="model.claimRelationship"
                :clearable="false"
                custom-error-msg="Favor seleccionar parentezco."
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Parentezco:"
                :options="claimRelationships"
                placeholder="Seleccione"
              />
            </validation-provider>
          </div>
          <div class="col-md-3">
            <validation-provider v-slot="{ errors }" rules="required">
              <custom-input
                v-model="model.claimPhone"
                custom-error-msg="Teléfono es requerido."
                :error="errors[0]"
                label="Teléfono:"
                mask-type="Phone"
                placeholder="(___) ___-____"
              />
            </validation-provider>
          </div>
        </div>
      </div>
      <div class="col-md-12 mt-2">
        <custom-text-area
          v-model="model.claimComment"
          label="Comentario:"
          :maxlength="500"
          :rows="4"
          show-char-count
        />
      </div>

      <div class="col-md-12 text-right mt-3 pt-1">
        <action-button
          i="fas fa-times-circle"
          text="Cancelar"
          variant="outline-danger mr-3"
          @click="$emit('on-cancel')"
        />
        <action-button
          i="fas fa-save"
          text="Guardar"
          variant="success"
          @click="handleSubmit(submit)"
        />
      </div>
    </div>
  </validation-observer>
</template>

<script>
import CustomDropDown from 'custom-drop-down';
import CustomTextArea from 'CustomTextArea';
import CustomDatePicker from 'custom-date-picker';
import alertMixin from '@/mixins/alert.mixin';
import { postClaim as _postClaim } from '@/modules/shared/cardHandling.api';
import CustomRadioGroup from '@/components/common/CustomRadio';
import {
  getCardClaimReasons as _getCardClaimReasons,
  getCardClaimRelationships as _getCardClaimRelationships,
} from '@/modules/shared/code.api.js';
import moment from 'moment';
import CustomInput from 'CustomInput';

export default {
  name: 'ClaimCard',
  components: {
    CustomDropDown,
    CustomTextArea,
    CustomDatePicker,
    CustomRadioGroup,
    CustomInput,
  },
  mixins: [alertMixin],
  props: {
    id: {
      type: Number,
      default: 0,
      require: true,
    },
    bankRequestDate: {
      type: Date,
      default: null,
    },
  },
  data: () => ({
    model: {
      becaCardId: null,
      claimComment: null,
      claimReasonId: null,
      claimTypeId: null,
      claimDate: null,
      claimName: null,
      claimRelationship: null,
      claimPhone: null,
      claimCardNumber: null,
    },
    claimTypeSelected: null,
    claimReasonSelected: null,
    claimReasons: [],
    claimRelationships: [],
    radioButtonsOptions: [
      { label: 'PIN', value: true },
      { label: 'Tarjeta', value: false },
    ],
  }),
  computed: {
    showReasons() {
      return this.claimTypeSelected == false;
    },
    beforeBankRequestDate() {
      return moment(this.bankRequestDate)
        .subtract(1, 'days')
        .toDate();
    },
  },
  mounted() {
    this.loadInitFilters();
  },
  methods: {
    async submit() {
      this.model.becaCardId = this.id;
      this.model.claimReasonId = this.claimReasonSelected;
      this.model.claimTypeId = this.claimTypeSelected ? 1 : 2;

      let model = {
        becaCardId: this.model.becaCardId,
        claimComment: this.model.claimComment,
        claimReasonId: this.model.claimReasonId?.id,
        claimTypeId: this.model.claimTypeId,
        claimDate: this.model.claimDate,
        cardNumber: this.model.cardNumber,
        claimName: this.model.claimName,
        phoneNumber: this.model.claimPhone,
        relationshipId: this.model.claimRelationship.id,
      };

      await _postClaim(model)
        .then(() => {
          this.ShowToast(
            'Confirmación',
            'El reclamo ha sido realizado exitosamente.',
            'success'
          );
          this.$emit('on-saved');
        })
        .catch((err) => {
          if (err && err.response && err.response.data) {
            this.ShowToast('Error', err.response.data.message, 'error');
          } else {
            this.ShowToast('Error', err.message, 'error');
          }
        });
    },
    async loadInitFilters() {
      const reasons = await _getCardClaimReasons();
      this.claimReasons = reasons.data;

      var filter = {};
      filter.list = [2, 3, 4];

      const relationships = await _getCardClaimRelationships(filter);
      this.claimRelationships = relationships.data;
    },
  },
};
</script>
<style scoped lang="scss"></style>
